import loaderConstants from '../services/loader/constants';
import redirectConstants from '../services/redirect/constants';

export function createAsyncAction(type, fn, opt) {
  let result;
  const options = opt || {};
  return (requestData, requestOptions) => async (dispatch) => {
    start(dispatch, requestData, options, type);
    try {
      result = !!fn ? await fn(requestData, requestOptions) : requestData;
    } catch (e) {
      result = e;
    }
    finish(dispatch, requestData, result, type, options);
    return result;
  };
}

function start(dispatch, requestData, options, type) {
  dispatch({type: loaderConstants.SHOW_LOADER});
  dispatch({
    type: `${type}_STARTED`,
    requestData: {
      ...requestData,
      ...options
    }
  });
}

function finish(dispatch, requestData, result, type) {
    const event = result.data.newEvent || result.data;
    if (event.isActive !== undefined && !event.isActive) {
        dispatch({ type: redirectConstants.REDIRECT_TO, data: { url: '/final', eventName: event.name } });
  }
  dispatch({type: loaderConstants.HIDE_LOADER});
  dispatch({type: result instanceof Error ? 'ERROR' : `${type}_ENDED`, data: result, requestData});
}